import mixins from 'vue-typed-mixins';
import { ElUploadInternalFileDetail } from 'element-ui/types/upload';

import { 取込Api } from '@/openapi/user';
import { E取込分類, E取込形式, E有無フラグ, E計画表示モード } from '@/openapi/enum';

import 取込Mixin from '@/entries/user/mixins/取込Mixin';
import EventObserverMixin from '@/mixins/EventObserverMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(取込Mixin, EventObserverMixin).extend({
  name: 'C勘定科目三表計画Import',

  props: {
    is貸借: {
      type: Boolean,
    },
    部門pk: {
      type: Number,
    },
  },
  computed: {
    disabled(): boolean {
      // 損益計算書(製造原価)時、部門未選択は非活性
      if (!this.is貸借 && this.部門pk === undefined) return true;
      // 年次計画選択中、年次作成出来ないなら非活性
      if (
        this.計画書.c計画表示モード === E計画表示モード.年次計画 &&
        (this.事業所.c計画作成期間 === 0 ||
          (this.事業所.c計画作成期間 === 1 && this.計画書.c第1期月次作成フラグ === E有無フラグ.あり))
      ) {
        return true;
      }

      return false;
    },
    importLabel(): string {
      let 表示モード = '';
      switch (this.計画書.c計画表示モード) {
        case E計画表示モード.月次計画第0期:
          表示モード = '月次0期';
          break;
        case E計画表示モード.月次計画第1期:
          表示モード = '月次1期';
          break;
        case E計画表示モード.年次計画:
          表示モード = '年次';
          break;
      }
      const plbscfNames = this.is貸借 ? '貸借' : '損益';
      return 表示モード + plbscfNames + '取込';
    },
    current取込分類(): E取込分類 {
      let e取込分類 = E取込分類.決算書;
      switch (this.計画書.c計画表示モード) {
        case E計画表示モード.月次計画第0期:
        case E計画表示モード.月次計画第1期:
          e取込分類 = this.is貸借
            ? E取込分類.三表計画月次貸借対照表
            : E取込分類.三表計画月次損益計算書_三表計画月次製造原価報告書;
          break;
        case E計画表示モード.年次計画:
          e取込分類 = this.is貸借
            ? E取込分類.三表計画年次貸借対照表
            : E取込分類.三表計画年次損益計算書_三表計画年次製造原価報告書;
          break;
      }
      return e取込分類;
    },
  },
  methods: {
    async importExcel(file: ElUploadInternalFileDetail) {
      this.取込データ種別Errors = [];
      if (!this.selectImportFile(E取込形式.xlsx, file)) return;

      const response = await UserApiUtility.ogApi(取込Api).import取込三表計画Xlsx(
        this.計画書.pk,
        this.current取込分類,
        file.raw,
        this.部門pk
      );

      if (this.is取込ValidationErrorResponse(response)) {
        const messages = this.取込データ種別Errors.flatMap((error) => {
          const message = [this.get取込データ種別Label(error.取込データ種別)];
          return message.concat(error.errors.map((e) => this.get取込Error(e)));
        });
        alert(messages.join('\n'));
        return;
      } else {
        alert('取込しました');
        // API再読み込みを促す
        this.publishEvent();
      }
    },
  },
});
